export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/values.3699c0bf-992774.png";